<head>

</head>

<script>
  import EntryCard from "./EntryCard.svelte";
  import { UnitsStore, ReadingsStore } from "../stores.js";
  import { onMount } from "svelte";

  export let ScrollId = "_AddReadingEl";



  let EntryCardsDiv;
  let Index = 0;

  function NewEntryCard() {
    Index = ++Index;
    let copy = $ReadingsStore;
    copy.push({
      user_height: "",
      object_distance: "",
      units: $UnitsStore,
      angle_difference: "",
      building_height: 0,
      steps: []
    });
    $ReadingsStore = copy;
    // console.log("Pushed");
  }

  // $: {
  //   console.log($ReadingsStore);
  //   console.log(JSON.stringify($ReadingsStore));
  // }
</script>

<div id={ScrollId} >
  <div id="readings_div" class="flex flex-row flex-wrap place-content-center" bind:this={EntryCardsDiv}>
    {#each $ReadingsStore as reading, idx}
    <EntryCard Index={idx} Deletable={idx !==0} />
    {/each}
  </div>

  <div class="flex flex-col justify-center items-center">
    <button class="btn btn-primary w-1/3 my-10" on:click={NewEntryCard}>Add Reading</button>
  </div>
</div>
